import { ArrowUpRight, Check } from "lucide-react";
import { Link } from "react-router-dom";

// "Why It's Different" long-form content sections — heading + paragraph + optional sub-bullets
// per section, with an optional highlighted/call-out variant. Shared by every product detail
// page that supports admin-authored `contentSections`. Renders nothing if there are none.
export const WhyItsDifferentSection = ({ contentSections, className = "", containerClassName = "py-16 md:py-20" }) => {
  if (!contentSections || contentSections.length === 0) return null;
  return (
    <section className={`border-t border-[var(--border-default)] bg-[var(--bg-secondary)] ${className}`}>
      <div className={`container-x ${containerClassName}`}>
        <div className="mb-12 max-w-2xl">
          <p className="overline mb-4">— Why It's Different</p>
          <h2 className="font-display text-3xl md:text-5xl text-white leading-[0.95]">
            BUILT TO A <span className="text-[var(--brand-primary)]">DIFFERENT STANDARD.</span>
          </h2>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-x-12 gap-y-12">
          {contentSections.map((section, i) => (
            <div
              key={section.heading || i}
              data-testid={`content-section-${i}`}
              className={section.highlight ? "lg:col-span-2 border-l-4 border-[var(--brand-primary)] bg-black/30 pl-6 py-5" : "border-t border-[var(--border-default)] pt-6"}
            >
              <h3 className={section.highlight ? "font-display text-2xl md:text-3xl text-[var(--brand-primary)] mb-3" : "font-display text-xl md:text-2xl text-white mb-3"}>
                {section.heading}
              </h3>
              {section.body && (
                <p className={section.highlight ? "text-white text-base md:text-lg leading-relaxed" : "text-[var(--text-secondary)] text-base md:text-lg leading-relaxed"}>
                  {section.body}
                </p>
              )}
              {section.bullets && section.bullets.length > 0 && (
                <ul className="mt-3 space-y-2">
                  {section.bullets.map((b, bi) => (
                    <li key={b || bi} className="flex items-start gap-2 text-base md:text-lg text-[var(--text-secondary)] leading-relaxed">
                      <Check size={14} className="text-[var(--brand-primary)] mt-1 shrink-0" strokeWidth={2.5} />
                      <span>{b}</span>
                    </li>
                  ))}
                </ul>
              )}
              {section.linkHref && section.linkText && (
                <Link to={section.linkHref} data-testid={`content-section-link-${i}`} className="inline-flex items-center gap-1.5 mt-4 text-sm font-mono text-[var(--brand-primary)] hover:underline">
                  {section.linkText} <ArrowUpRight size={14} />
                </Link>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
